<template>
  <v-dialog v-model="Activo" persistent max-width="720">
    <v-form ref="form1">
      <v-container grid-list-sm>
        <v-card class="mx-auto" :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap text-center>
              <v-flex>
                <h3 class="title">{{ Titulo }}</h3>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap text-center>
              <v-flex>
                <span class="subheading font-weight-light mr-1">{{
                  Subtitulo
                }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-data-table
                  :headers="grillaHeaders_Articulos"
                  :items="Items"
                  :loading="grillaLoading_Articulos"
                  :items-per-page="10"
                  :footer-props="{
                    itemsPerPageText: 'Mostrar'
                  }"
                  dense
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.Nombre }}</td>
                      <td>{{ item.Cantidad }}</td>
                      <td>{{ item.Precio | esMoneda }}</td>
                      <td>{{ item.Importe | esMoneda }}</td>
                    </tr>
                  </template>
                  <template v-slot:no-data
                    >-</template
                  >
                  <template v-slot:footer>
                    <v-container>
                      <v-layout>
                        <v-flex class="text-right">
                          Total
                          <strong>{{ Total | esMoneda }}</strong>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="ejecutarAccion('Cerrar')">
              Cerrar
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalDetalleArticulos",
  props: {
    activo: Boolean,
    titulo: String,
    subtitulo: String,
    items: {}
  },
  data() {
    return {
      Activo: false,
      Titulo: "",
      Subtitulo: "",
      Items: [],
      Total: 0,
      grillaHeaders_Articulos: [
        { text: "Artículo", value: "Nombre", width: "50%" },
        { text: "Cantidad", sortable: false },
        { text: "Precio", sortable: false },
        { text: "Importe", sortable: false }
      ],
      grillaLoading_Articulos: false
    };
  },
  watch: {
    activo() {
      this.Activo = this.activo;
      if (this.Activo) {
        this.Titulo = this.titulo;
        this.Subtitulo = this.subtitulo;
        this.Items = this.items;
        this.Total = 0;
        this.Items.forEach(item => {
          this.Total += item.Importe;
        });
      }
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.$emit("ejecutarAccion", accion, null);
    }
  }
};
</script>
